import { ValuesByComparingDimension } from '../barChart/barChart.types';
import { getDimensionInfo } from '../lineGraph/helpers/getDimensionInfo';

export const getGlobalDataProperties = ({
	dimensionInfo = [],
	decimals,
}: {
	dimensionInfo:
		| ReturnType<typeof getDimensionInfo>
		| ValuesByComparingDimension;
	decimals: number;
}) => {
	if (dimensionInfo.length <= 0) {
		return {
			globalMin: 0,
			globalMax: 0,
			globalMiddle: 0,
			tickCount: 0,
			tickValues: [],
		};
	}

	const minTickSize = 1 / Math.pow(10, decimals);
	const minTickCount = 2;
	const maxTickCount = 5;

	const { min: rawGlobalMin, max: rawGlobalMax } = dimensionInfo.reduce(
		({ min: globalMin, max: globalMax }, { min = 0, max = Infinity }) => {
			return {
				min: Math.min(globalMin, min),
				max: Math.max(globalMax, max),
			};
		},
		{ min: 0, max: 0 } as { min: number; max: number },
	);

	const globalMax =
		rawGlobalMin < 0 && rawGlobalMax === 0
			? rawGlobalMax
			: Math.max(rawGlobalMin + minTickSize * (minTickCount - 1), rawGlobalMax);

	const globalMin =
		rawGlobalMin < 0 && rawGlobalMax === 0
			? Math.min(rawGlobalMax - minTickSize * (minTickCount - 1), rawGlobalMin)
			: rawGlobalMin;

	const rawTickCount = 1 + (globalMax - globalMin) / minTickSize;

	const tickCount = Math.min(rawTickCount, maxTickCount);

	const tickValues =
		rawGlobalMax === 0 && rawGlobalMin === 0
			? [0, minTickSize]
			: tickCount <= 2
				? [globalMin < 0 ? globalMin : globalMax]
				: undefined;

	const globalMiddle = (globalMin + globalMax) / 2;

	return {
		globalMin,
		globalMax,
		globalMiddle,
		tickCount,
		tickValues,
	};
};
